import BaseDto from '../../_common/BaseDto';

/**
 * @class PackPaymentLinkRequestBuilder
 * @description Builder class for PackPaymentLinkRequest
 */
class PackPaymentLinkRequestBuilder {
    /**
     * @param {string} toltioReferral - The Toltio referral code.
     * @returns {PackPaymentLinkRequestBuilder}
     */
    withToltioReferral(toltioReferral) {
        this.toltio_referral = toltioReferral;
        return this;
    }

    /**
     * @param {string} successUrl - The URL to redirect to on successful payment.
     * @returns {PackPaymentLinkRequestBuilder}
     */
    withSuccessUrl(successUrl) {
        this.success_url = successUrl;
        return this;
    }

    /**
     * @param {string} cancelUrl - The URL to redirect to if the payment is canceled.
     * @returns {PackPaymentLinkRequestBuilder}
     */
    withCancelUrl(cancelUrl) {
        this.cancel_url = cancelUrl;
        return this;
    }

    /**
     * @returns {PackPaymentLinkRequest} A new instance of PackPaymentLinkRequest.
     */
    build() {
        return new PackPaymentLinkRequest(this);
    }
}

/**
 * @class PackPaymentLinkRequest
 * @extends BaseDto
 * @description Represents a request for creating a pack payment link.
 */
class PackPaymentLinkRequest extends BaseDto {
    /**
     * @constructor
     * @param {PackPaymentLinkRequestBuilder} builder - The builder object containing the request data.
     */
    constructor(builder) {
        super();
        this.toltio_referral = builder.toltio_referral;
        this.success_url = builder.success_url;
        this.cancel_url = builder.cancel_url;
    }

    /**
     * @readonly
     * @static
     * @type {typeof PackPaymentLinkRequestBuilder}
     * @description Getter for the Builder class.
     */
    static get Builder() {
        return PackPaymentLinkRequestBuilder;
    }
}

export default PackPaymentLinkRequest;
